import { useSetRecoilState } from 'recoil';
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { toastApiError } from '../../utils/ApiError';
import { selectedPageAtom } from '../../atoms/Page';
import { Institution } from '../../interfaces/Institution';
import { Department } from '../../interfaces/Department';
import { PageType } from '../../interfaces/Page';
import { getInstitutions } from '../../services/Institution';
import { getDepartments } from '../../services/Department';
import {
  PersonnelOnDuty,
  PersonnelOnDutyRequest,
} from '../../interfaces/PersonnelOnDuty';
import { getPersonnelsOnDuty } from '../../services/PersonnelOnDuty';
import Waiting from '../Waiting';
import { sharedStyles } from '../../utils/Style';
import PersonnelOnDutyTable from './PersonnelOnDutyTable';

const PersonnelOnDutyPage = () => {
  const setSelectedPage = useSetRecoilState(selectedPageAtom);

  const [loadingPersonnels, setLoadingPersonnels] = useState(false);
  const [loadingInstitutions, setLoadingInstitutions] = useState(false);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [institutions, setInstitutions] = useState<Institution[]>([]);
  const [departments, setDepartments] = useState<Department[]>([]);
  const [personnelsOnDuty, setPersonnelsOnDuty] = useState<PersonnelOnDuty[]>(
    [],
  );

  useEffect(() => {
    setSelectedPage(PageType.PERSONNEL_ON_DUTY);

    setLoadingInstitutions(true);
    getInstitutions()
      .then((fetchedInstitutions) => setInstitutions(fetchedInstitutions))
      .catch((err) => toastApiError(err))
      .finally(() => setLoadingInstitutions(false));

    setLoadingDepartments(true);
    getDepartments()
      .then((fetchedDepartments) => setDepartments(fetchedDepartments))
      .catch((err) => toastApiError(err))
      .finally(() => setLoadingDepartments(false));

    setLoadingPersonnels(true);
    getPersonnelsOnDuty({ day: new Date() })
      .then((personnels) => setPersonnelsOnDuty(personnels))
      .catch((err) => toastApiError(err))
      .finally(() => setLoadingPersonnels(false));
  }, []);

  const handleSearch = (filters: PersonnelOnDutyRequest) => {
    setLoadingPersonnels(true);
    getPersonnelsOnDuty(filters)
      .then((personnels) => setPersonnelsOnDuty(personnels))
      .catch((err) => toastApiError(err))
      .finally(() => setLoadingPersonnels(false));
  };

  const loading =
    loadingInstitutions || loadingDepartments || loadingPersonnels;

  return (
    <Box component='div'>
      <Waiting open={loading} />
      <Box component='div' sx={sharedStyles.pageBody}>
        <PersonnelOnDutyTable
          personnels={personnelsOnDuty}
          institutions={institutions}
          departments={departments}
          onFilter={handleSearch}
        />
      </Box>
    </Box>
  );
};

export default PersonnelOnDutyPage;
